<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

const icons = import.meta.glob('~/assets/icons-registry/ui-custom/airline/**/*.svg', {
  eager: true,
  import: 'default',
});

interface Properties {
  iataCode?: string;
  small?: boolean;
  name?: string;
  class?: HTMLAttributes['class'];
}

const properties = defineProps<Properties>();
const prefix = properties.small ? 'small/' : '';
const iconComponent = icons[`/assets/icons-registry/ui-custom/airline/${prefix}${properties.iataCode}-logo.svg`];
</script>

<template>
  <span
    v-if="iconComponent"
    :role="properties.name ? 'img' : undefined"
    :aria-label="properties.name"
    :aria-hidden="!properties.name || undefined"
  >
    <component
      :is="iconComponent"
      :class="properties.class"
      width="110"
      filled
      :font-controlled="false"
      focusable="false"
    />
  </span>
  <span
    v-else
    :aria-hidden="!properties.name || undefined"
  >
    <span class="sm:hidden">{{ properties.iataCode }}</span>
    <span class="hidden sm:block">{{ properties.name }}</span>
  </span>
</template>
